import { EMPTY_ELEMENT } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/critical-element.const';

export const getTabItems = (isDisabled) => [
  { label: 'Details', value: 'details', isDisabled: false },
  { label: 'Version History', value: 'history', isDisabled },
];

export const getEmptyElement = (year) => ({
  ...EMPTY_ELEMENT,
  enteringClassYear: year,
  details: [{ category: '', focusArea: '', subArea: '', options: [] }],
});
